import { Navigate, useLocation } from 'react-router';
import useAuthContext from '@/features/auth/_shared/contexts/auth.context';
import { Spinner } from '@/components/_ui/spinner';
import { memo, useMemo } from 'react';
import { APP_ROUTES } from '@/app/app.route.constants';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute = memo(({ children }: ProtectedRouteProps) => {
  const { isAuthenticated, hydrated, state } = useAuthContext();
  const location = useLocation();
  const fullPath = useMemo(() => location.pathname + location.search, [location]);

  // Wait for hydration before deciding
  if (!hydrated || state?.loading) {
    return (
      <div className="flex justify-center items-center flex-1 h-screen">
        <Spinner className="h-[40px] w-[40px]" />
      </div>
    );
  }

  // If not authenticated, redirect to login
  if (!isAuthenticated) {
    return <Navigate to={APP_ROUTES.auth.login.getHref(fullPath)} replace />;
  }

  return children;
});

ProtectedRoute.displayName = 'ProtectedRoute';
